import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum bulkLimitConfigFileType {

    UPLOAD_BULK_LIMIT_CONFIG_FILE = "@@auth/UPLOAD_BULK_LIMIT_CONFIG_FILE",
    UPLOAD_BULK_LIMIT_CONFIG_FILE_SUCCESS = "@@auth/UPLOAD_BULK_LIMIT_CONFIG_FILE_SUCCESS",
    UPLOAD_BULK_LIMIT_CONFIG_FILE_ERROR = "@@auth/UPLOAD_BULK_LIMIT_CONFIG_FILE_ERROR",
    RESET_UPLOAD_BULK_LIMIT_CONFIG_FILE = "@@auth/RESET_UPLOAD_BULK_LIMIT_CONFIG_FILE",

    FETCH_BULK_LIMIT_CONFIG_FILE = "@@auth/FETCH_BULK_LIMIT_CONFIG_FILE",
    FETCH_BULK_LIMIT_CONFIG_FILE_SUCCESS = "@@auth/FETCH_BULK_LIMIT_CONFIG_FILE_SUCCESS",
    FETCH_BULK_LIMIT_CONFIG_FILE_ERROR = "@@auth/FETCH_BULK_LIMIT_CONFIG_FILE_ERROR",
    RESET_FETCH_BULK_LIMIT_CONFIG_FILE = "@@auth/RESET_FETCH_BULK_LIMIT_CONFIG_FILE",

    BULK_LIMIT_CONFIG_FILE_DOWNLOAD = "@@auth/BULK_LIMIT_CONFIG_FILE_DOWNLOAD",
    BULK_LIMIT_CONFIG_FILE_DOWNLOAD_SUCCESS = "@@auth/BULK_LIMIT_CONFIG_FILE_DOWNLOAD_SUCCESS",
    BULK_LIMIT_CONFIG_FILE_DOWNLOAD_ERROR = "@@auth/BULK_LIMIT_CONFIG_FILE_DOWNLOAD_ERROR",
    RESET_BULK_LIMIT_CONFIG_FILE_DOWNLOAD = "@@auth/RESET_BULK_LIMIT_CONFIG_FILE_DOWNLOAD",

    FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL = "@@auth/FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL",
    FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL_SUCCESS = "@@auth/FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL_SUCCESS",
    FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL_ERROR = "@@auth/FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL_ERROR",
    RESET_FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL = "@@auth/RESET_FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL",

    BULK_LIMIT_CONFIG_FILE_VERSION = "@@auth/BULK_LIMIT_CONFIG_FILE_VERSION",
    BULK_LIMIT_CONFIG_FILE_VERSION_SUCCESS = "@@auth/BULK_LIMIT_CONFIG_FILE_VERSION_SUCCESS",
    BULK_LIMIT_CONFIG_FILE_VERSION_ERROR = "@@auth/BULK_LIMIT_CONFIG_FILE_VERSION_ERROR",
    RESET_BULK_LIMIT_CONFIG_FILE_VERSION = "@@auth/RESET_BULK_LIMIT_CONFIG_FILE_VERSION",

    PUBLISH_BULK_LIMIT_CONFIG_FILE = "@@auth/BULK_LIMIT_CONFIG_FILE_PUBLISH",
    PUBLISH_BULK_LIMIT_CONFIG_FILE_SUCCESS = "@@auth/PUBLISH_BULK_LIMIT_CONFIG_FILE_SUCCESS",
    PUBLISH_BULK_LIMIT_CONFIG_FILE_ERROR = "@@auth/PUBLISH_BULK_LIMIT_CONFIG_FILE_ERROR",
    RESET_PUBLISH_BULK_LIMIT_CONFIG_FILE = "@@auth/RESET_PUBLISH_BULK_LIMIT_CONFIG_FILE",

    APPROVE_BULK_LIMIT_CONFIG_FILE = "@@auth/APPROVE_BULK_LIMIT_CONFIG_FILE",
    APPROVE_BULK_LIMIT_CONFIG_FILE_SUCCESS = "@@auth/APPROVE_BULK_LIMIT_CONFIG_FILE_SUCCESS",
    APPROVE_BULK_LIMIT_CONFIG_FILE_ERROR = "@@auth/APPROVE_BULK_LIMIT_CONFIG_FILE_ERROR",
    RESET_APPROVE_BULK_LIMIT_CONFIG_FILE = "@@auth/RESET_APPROVE_BULK_LIMIT_CONFIG_FILE",

    REJECT_BULK_LIMIT_CONFIG_FILE = "@@auth/REJECT_BULK_LIMIT_CONFIG_FILE",
    REJECT_BULK_LIMIT_CONFIG_FILE_SUCCESS = "@@auth/REJECT_BULK_LIMIT_CONFIG_FILE_SUCCESS",
    REJECT_BULK_LIMIT_CONFIG_FILE_ERROR = "@@auth/REJECT_BULK_LIMIT_CONFIG_FILE_ERROR",
    RESET_REJECT_BULK_LIMIT_CONFIG_FILE = "@@auth/RESET_REJECT_BULK_LIMIT_CONFIG_FILE",

    FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG = "@@auth/FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG",
    FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG_SUCCESS = "@@auth/FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG_SUCCESS",
    FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG_ERROR = "@@auth/FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG_ERROR",
    RESET_FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG = "@@auth/RESET_FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG",

    DELETE_BULK_LIMIT_CONFIG_FILE = "@@auth/DELETE_BULK_LIMIT_CONFIG_FILE",
    DELETE_BULK_LIMIT_CONFIG_FILE_SUCCESS = "@@auth/DELETE_BULK_LIMIT_CONFIG_FILE_SUCCESS",
    DELETE_BULK_LIMIT_CONFIG_FILE_ERROR = "@@auth/DELETE_BULK_LIMIT_CONFIG_FILE_ERROR",
    RESET_DELETE_BULK_LIMIT_CONFIG_FILE = "@@auth/RESET_DELETE_BULK_LIMIT_CONFIG_FILE",
}
// Action Types
export type BulkLimitConfigFileAction = {
    type:
    | bulkLimitConfigFileType.UPLOAD_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.RESET_UPLOAD_BULK_LIMIT_CONFIG_FILE

    | bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.RESET_FETCH_BULK_LIMIT_CONFIG_FILE

    | bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_DOWNLOAD
    | bulkLimitConfigFileType.RESET_BULK_LIMIT_CONFIG_FILE_DOWNLOAD

    | bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL
    | bulkLimitConfigFileType.RESET_FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL

    | bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_VERSION
    | bulkLimitConfigFileType.RESET_BULK_LIMIT_CONFIG_FILE_VERSION

    | bulkLimitConfigFileType.PUBLISH_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.RESET_PUBLISH_BULK_LIMIT_CONFIG_FILE

    | bulkLimitConfigFileType.APPROVE_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.RESET_APPROVE_BULK_LIMIT_CONFIG_FILE

    | bulkLimitConfigFileType.REJECT_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.RESET_REJECT_BULK_LIMIT_CONFIG_FILE

    | bulkLimitConfigFileType.FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG
    | bulkLimitConfigFileType.RESET_FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG

    | bulkLimitConfigFileType.DELETE_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.RESET_DELETE_BULK_LIMIT_CONFIG_FILE;
    payload: any;
};
export type uploadBulkLimitConfigFileType = {
    bulkLimitConfigFile: File;
}
export type BulkLimitConfigDownloadFileType = {
    downloadURL: string
}
export type BulkLimitConfigFileDetail = {
    externalID: string,
}
export type BulkLimitConfigFileVersionType = {
    externalId: string,
    filter: FilterMetadata
}
export type BulkLimitConfigFileMakerRemarkType = {
    remarkPayload: { makerRemarks: string },
    externalId: string
}
export type BulkLimitConfigFileCheckerRemarkType = {
    remarkPayload: { checkerRemarks: string },
    externalId: string
}
// Saga Types
export type uploadBulkLimitConfigFileSaga = {
    type: string,
    payload: uploadBulkLimitConfigFileType
}
export type fetchBulkLimitConfigFileSaga = {
    type: string,
    payload: FilterMetadata
}
export type downloadBulkLimitConfigFileSaga = {
    type: string,
    payload: BulkLimitConfigDownloadFileType
}
export type fetchBulkLimitConfigFileDetailSaga = {
    type: string,
    payload: BulkLimitConfigFileDetail
}
export type BulkLimitConfigFileVersionSaga = {
    type: string,
    payload: BulkLimitConfigFileVersionType
}
export type BulkLimitConfigFileMakerRemarkSaga = {
    type: string,
    payload: BulkLimitConfigFileMakerRemarkType
}
export type BulkLimitConfigFileCheckerRemarkSaga = {
    type: string,
    payload: BulkLimitConfigFileCheckerRemarkType
}
// Reducer Types
type reducerPayload = {
    data: FetchApiResponse<any>; // Future option: FetchApiResponse<any> | Record<string, unknown>
    error: string;
}
export type BulkLimitConfigFileReducer = {
    type:
    | bulkLimitConfigFileType.UPLOAD_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.UPLOAD_BULK_LIMIT_CONFIG_FILE_SUCCESS
    | bulkLimitConfigFileType.UPLOAD_BULK_LIMIT_CONFIG_FILE_ERROR
    | bulkLimitConfigFileType.RESET_UPLOAD_BULK_LIMIT_CONFIG_FILE

    | bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_SUCCESS
    | bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_ERROR
    | bulkLimitConfigFileType.RESET_FETCH_BULK_LIMIT_CONFIG_FILE

    | bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_DOWNLOAD
    | bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_DOWNLOAD_SUCCESS
    | bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_DOWNLOAD_ERROR
    | bulkLimitConfigFileType.RESET_BULK_LIMIT_CONFIG_FILE_DOWNLOAD

    | bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL
    | bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL_SUCCESS
    | bulkLimitConfigFileType.FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL_ERROR
    | bulkLimitConfigFileType.RESET_FETCH_BULK_LIMIT_CONFIG_FILE_DETAIL

    | bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_VERSION
    | bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_VERSION_SUCCESS
    | bulkLimitConfigFileType.BULK_LIMIT_CONFIG_FILE_VERSION_ERROR
    | bulkLimitConfigFileType.RESET_BULK_LIMIT_CONFIG_FILE_VERSION

    | bulkLimitConfigFileType.PUBLISH_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.PUBLISH_BULK_LIMIT_CONFIG_FILE_SUCCESS
    | bulkLimitConfigFileType.PUBLISH_BULK_LIMIT_CONFIG_FILE_ERROR
    | bulkLimitConfigFileType.RESET_PUBLISH_BULK_LIMIT_CONFIG_FILE

    | bulkLimitConfigFileType.APPROVE_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.APPROVE_BULK_LIMIT_CONFIG_FILE_SUCCESS
    | bulkLimitConfigFileType.APPROVE_BULK_LIMIT_CONFIG_FILE_ERROR
    | bulkLimitConfigFileType.RESET_APPROVE_BULK_LIMIT_CONFIG_FILE

    | bulkLimitConfigFileType.REJECT_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.REJECT_BULK_LIMIT_CONFIG_FILE_SUCCESS
    | bulkLimitConfigFileType.REJECT_BULK_LIMIT_CONFIG_FILE_ERROR
    | bulkLimitConfigFileType.RESET_REJECT_BULK_LIMIT_CONFIG_FILE

    | bulkLimitConfigFileType.FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG
    | bulkLimitConfigFileType.FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG_SUCCESS
    | bulkLimitConfigFileType.FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG_ERROR
    | bulkLimitConfigFileType.RESET_FETCH_BULK_FILE_SPECIFIC_LIMIT_CONFIG

    | bulkLimitConfigFileType.DELETE_BULK_LIMIT_CONFIG_FILE
    | bulkLimitConfigFileType.DELETE_BULK_LIMIT_CONFIG_FILE_SUCCESS
    | bulkLimitConfigFileType.DELETE_BULK_LIMIT_CONFIG_FILE_ERROR
    | bulkLimitConfigFileType.RESET_DELETE_BULK_LIMIT_CONFIG_FILE;
    payload: reducerPayload;
};
export type BulkLimitConfigFileReducerStateWithoutListObject = {
    loading?: boolean;
    data?: CreateApiResponse<any>;
    error?: string | null;
};
export type BulkLimitConfigFileReducerStateWithListObject = {
    loading?: boolean;
    data?: FetchApiResponse<any>;
    error?: string | null;
};